import { Injectable } from '@angular/core';
import { ServiceBase } from './service.base';
import { AvisosApi } from '../api/avisos.api';
import { IAviso } from '../models/aviso';
import { IAvisoDTO } from '../dto/aviso-dto';
import { Observable } from 'rxjs';
import { Tso } from 'ts-odata';
import { ApiResultado } from '../models/api-resultado';

@Injectable()
export class AvisosService extends ServiceBase<IAviso, IAvisoDTO> {

    constructor(private api: AvisosApi) {
        super(api);
    }

    naoLidos(fixados: boolean): Observable<ApiResultado<IAvisoDTO>> {
        let query = new Tso(`naolidos/${fixados}`);
        query.select(["Id", "Titulo", "Mensagem", "DataCriacao", "EhHtml"]);
        query.orderBy("DataCriacao").desc();

        query.top(10);

        return this.odata(query);
    }

    marcarLida(id: string): Observable<boolean> {
        return new Observable<boolean>(observer => {
            this.api.doGet(`marcar-lida/${id}`).subscribe(() => {
                observer.next(true);
                observer.complete();
            });
        });
    }
}
